module.exports = __webpack_public_path__ + "img/configurationProduction.25c22b18.png";